import { stringLookup, zLookup } from '@/utils/zodHelper';
import { z } from 'zod';

const CauseTranslationSchema = z.object({
  id: z.number().optional(),
  name: z.string().max(200),
  language_code: stringLookup().or(z.string()),
  inlineIndex: z.number().optional(),
});

export const CauseSchema = z.object({
  id: z.number().optional(),
  translations: z.array(CauseTranslationSchema).optional(),
  units: z.array(zLookup()),
  origin: zLookup(),
  is_active: z.boolean().optional(),
  order: z.number(),
});

export type CauseSchemaType = z.infer<typeof CauseSchema>;
